import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import DashboardBookList from 'rebook/apps/dashboard/components/DashboardBookList';
import DashboardBookListEmpty from 'rebook/apps/dashboard/components/DashboardBookListEmpty';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


class DashboardBooksetBookListBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;

    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBooksetDetail();
  }

  fetchBooksetDetail() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;
    // fix for earlier version of dashboard

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = fixQueryString(this.state.block.resource_uri, { booklimit: '10' });
    this.props.DashboardBlockListActions.fetchDashboardBlock(url, { apiVersion: 4 })
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                bookset: data,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard bookset books due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { block, blockId } = this.state;
    const { dashboardBlockList, itemKey } = this.props;
    const bookset = get(dashboardBlockList[blockId], 'bookset', {});

    const {
      picture, short_name: shortName, books, active_book_count: activeBookCount,
      absolute_url: absoluteUrl, show_book_order: showBookOrder, rubrics,
    } = bookset;

    // the block title overrides the bookset's name
    const blockTitle = block && block.title || bookset && bookset.name;

    return (bookset && get(bookset, 'books.length', 0) > 0)
      ? (
        <DashboardBookList
          picture={picture}
          pictureName={shortName}
          title={blockTitle}
          books={books}
          bookCount={activeBookCount}
          linkMore={absoluteUrl}
          shouldShowBookOrder={showBookOrder}
          rubrics={rubrics}
          itemKey={itemKey} />
      )
      : <DashboardBookListEmpty />;
  }
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBooksetBookListBlock.propTypes = {
  block: PropTypes.shape({
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBooksetBookListBlock);
